/**
 * 封装的axios文件
 */
import Promise from 'es6-promise'
import axios from 'axios'
import pub from './public';

Promise.polyfill()

axios.defaults.withCredentials = true;
axios.interceptors.request.use(function (config) {
    config.headers.token = '';
    return config;
}, function (error) {
    // 请求错误
    return Promise.reject(error)
})
axios.interceptors.response.use(
  response => {
      // 响应数据
      if (["application/vnd.ms-excel;charset=utf-8", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"].includes(response.headers['content-type'])) {
        return response
      } else {
        return response.data;
      }
  },
  error => {
      if (!error.response) {

          return;
      }
      if (error && error.response) {
          switch (error.response.status) {
              case 502:

                  break;
              case 400:
              case 500:
              case 504:

                  break;
              case 401:

                  break;
              case 403:
                  if (error.response.data.data) {
                      pub.removeCookie("SID");
                      window.location = error.response.data.data;
                      return
                  } else {
                      // message.error('暂无权限访问');
                      window.location = `${window.location.origin}#/errPage`
                      return
                  }

                break;
              default:
                  break;
          }
      }
      return Promise.reject(error);
  }
)

/**
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
var http = {
    get: (url, params, headers = {}, config = {}) => {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                params: params,
                headers: defaultHeaders(headers),
                ...config
            }).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    del: (url, params, headers = {}) => {
        return new Promise((resolve, reject) => {
            axios.delete(url, {
                params: params,
                headers: defaultHeaders(headers)
            }).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err)
            });
        });
    },
    post: (url, params, headers = {}, config = {}) => {
        return new Promise((resolve, reject) => {
            axios.post(url, params, {headers: defaultHeaders(headers)}, config)
              .then(res => {
                resolve(res);
            })
              .catch(err => {
                  reject(err)
              });
        });
    },
    put: (url, params, headers = {}) => {
        return new Promise((resolve, reject) => {
            axios.put(url,params, {headers: defaultHeaders(headers)})
              .then(res => {
                  resolve(res);
              })
              .catch(err => {
                  reject(err)
              });
        });
    }
};
/**
 * 默认Headers
 * @returns {{"Content-Type": string, token: (executor|string|CancelToken|string), projectId}}
 */
const defaultHeaders = (headers = {}) => (Object.assign({}, {
    'Content-Type': "application/json",
    projectId: sessionStorage.getItem('projectId')
}, headers))

export default http;
